/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Name_RequiredInputs */



/**
* | output |
* | --- |
* | "Please enter a preset name" |
*
* @param {Audio_Description_Export_Preset_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_name_required = /** @type {((inputs?: Audio_Description_Export_Preset_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez saisir un nom de préréglage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie einen voreingestellten Namen ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nome predefinito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, введите предустановленное имя.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, introduzca un nombre preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入预设名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセット名を入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया एक पूर्व निर्धारित नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, insira um nome predefinido.")
	return /** @type {LocalizedString} */ ("Please enter a preset name")
});